import React, { useState } from "react";
import ReactModal from "react-modal";
import style from "../SendMerchantLink/SendMerchantLink.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import { changeOtpMobileNumber } from "../../../../../api";
import toast from "react-hot-toast";
import CloseIcon16 from "../../../../assets/svg/icons/common/CloseIcon16";
const phoneRegex = /^\(?(?:[0-9]{3})\)?[-.\s+]?(?:[0-9]{3})[-.\s+]?(?:[0-9]{4})$/;
const OTP_PHONE_PREFIX = '+1';

function EditMobile({ open, onClose, appData, fetchApplication }) {

  const [otpNumber, setOtpNumber] = useState(appData?.otp_phone_number ? parseInt(appData?.otp_phone_number?.toString()?.substring(2)) : "");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const validatePhoneNumber = (number) => {
    return phoneRegex.test(number);
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setOtpNumber(value);
    if (validatePhoneNumber(value)) {
      setError("");
    } else {
      setError("Invalid phone number");
    }
  };

  const updateOTPPhone = async () => {
    const payload = {
      otp_phone_number: OTP_PHONE_PREFIX + otpNumber,
      editslug: appData?.editslug,
      id: appData?.id
    }
    setIsLoading(true);
    setError("");
    const toastId = toast.loading("Loading...");
    let response;
    try {
      response = await changeOtpMobileNumber(payload);
    } catch (error) {
      // A retention refusal comes back as a 403, which rejects the promise; without
      // this the loading toast never resolves and the modal stays locked.
      const message = error?.response?.data?.message || "Something went wrong!";
      toast.error(message, { id: toastId });
      setIsLoading(false);
      setError(message);
      return;
    }

    if (response.status) {
      toast.success("OTP mobile updated successfully!", { id: toastId });
      fetchApplication();
      onClose();
    } else {
      toast.error("Something went wrong!", { id: toastId });
      setIsLoading(false);
      setError('Something went wrong!');
    }
  }

  return (
    <ReactModal isOpen={open} className={style.react_modal}>
      <div className={style.header}>
        <ButtonIcon onClick={onClose}>
          <CloseIcon16 />
        </ButtonIcon>
      </div>

      <div className={style.body}>
        <h6>Edit OTP Mobile</h6>

        <div className={style.form_group}>
          <label htmlFor="otp_phone_number">OTP Mobile Number</label>
          <input
            type="text"
            name="otp_phone_number"
            id="otp_phone_number"
            value={otpNumber}
            onChange={handleChange}
            className={style.input_select}
          />
          {error && <span className={style.error}>{error}</span>}
        </div>
      </div>

      <div className={style.footer_modal}>
        <div className={style.button_group}>
          <ButtonIcon textColor="#254FE2" onClick={onClose}>
            Cancel
          </ButtonIcon>
          <ButtonIcon
            bgColor={"#4C70EF"}
            textColor="#FFF"
            isLoading={isLoading}
            disabled={error}
            onClick={() => updateOTPPhone()}
          >
            Send
          </ButtonIcon>
        </div>
      </div>
    </ReactModal>
  );
}

export default EditMobile;
